export const ROUTES = {
  AUTH: {
    CHANGE_PASSWORD: "/change-password",
  },
  PORTAL: {
    LANDING: "/portal",
  },
  MEMBER_360: {
    LANDING: "/member-360",
  },
  MEMBER360_LAB: {
    DASHBOARD: "/member360",
    MEMBERS: "/member360/members",
    MEMBER_WORKSPACE_ROOT: "/member360/members",
    TASKS: "/member360/tasks",
    CARE_JOURNEYS: "/member360/care-journeys",
    RISK_INTELLIGENCE: "/member360/risk-intelligence",
    CARE_OPTIONS: "/member360/care-options",
    MESSAGES: "/member360/messages",
    DOCUMENTS: "/member360/documents",
    ADMIN: "/member360/admin",
  },
  PROVIDERS: {
    LANDING: "/providers",
  },
  CODING: {
    WORKLIST: "/coding",
    CHASE_ROOT: "/coding/chases",
    WORKBENCH_ROOT: "/coding/workbench",
  },
  RIDE_BOOKING: "/ride-booking",
  DASHBOARD: "/dashboard",
  JOBS: {
    STATUS_CENTER: "/jobs/status-center",
    IMPORT_DATA: "/jobs/import-data",
  },
  DOCS: "/docs",
  SETTINGS: "/settings",
  CHAT: "/chat",
  ADMIN: {
    MASTER: "/admin/master",
  },
  STAFF: {
    LOGIN: "/staff/login",
    CONSOLE: "/staff",
    USERS: "/staff/users",
    BOOTSTRAP: "/staff/bootstrap",
  },
};
